module.exports = __webpack_public_path__ + "static/media/Report.8f0f656e.svg";